import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';
import { useUserRouteMapperCtHook } from './use-user-route-mapper-ct.hook';
import { useUserRouteMapperAmrHook } from './use-user-route-mapper-amr.hook';

export function useUserRouteMapperHook() {
    const { isAmr } = useAssignedAppTypeContext();
    const amrRoutes = useUserRouteMapperAmrHook();
    const ctRoutes = useUserRouteMapperCtHook();

    return isAmr ? amrRoutes : ctRoutes;
}
